import { type MCPServerInfo } from '../../types';

const PrometheusServer: MCPServerInfo = {
  serverId: 'PROMETHEUS',
  name: 'Prometheus',
  slug: 'prometheus',
  description:
    'Prometheus MCP Server for AWS Managed Prometheus - execute PromQL queries, list metrics, and retrieve workspace information with AWS SigV4 authentication.',
  source: {
    sourceType: 'LOCAL_PACKAGE',
    transport: 'STDIO',
    commandFunction: `(config) => {
  const args = ['awslabs.prometheus-mcp-server@latest'];
  if (config.workspaceUrl) {
    args.push('--url', config.workspaceUrl);
  }
  if (config.awsRegion) {
    args.push('--region', config.awsRegion);
  }
  if (config.awsProfile) {
    args.push('--profile', config.awsProfile);
  }
  const env = {
    FASTMCP_LOG_LEVEL: 'INFO'
  };
  if (config.awsRegion) {
    env.AWS_REGION = config.awsRegion;
  }
  if (config.awsProfile) {
    env.AWS_PROFILE = config.awsProfile;
  }
  if (config.awsAccessKeyId) {
    env.AWS_ACCESS_KEY_ID = config.awsAccessKeyId;
  }
  if (config.awsSecretAccessKey) {
    env.AWS_SECRET_ACCESS_KEY = config.awsSecretAccessKey;
  }
  if (config.awsSessionToken) {
    env.AWS_SESSION_TOKEN = config.awsSessionToken;
  }
  return {
    command: 'uvx',
    args,
    env
  };
}`
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['awsRegion'],
    properties: {
      workspaceUrl: {
        type: 'string',
        description:
          'AWS Managed Prometheus workspace URL (e.g. https://aps-workspaces.us-east-1.amazonaws.com/workspaces/ws-<Workspace ID>)',
        sensitive: false
      },
      awsRegion: {
        type: 'string',
        description: 'AWS region for the Prometheus workspace (e.g. us-east-1)',
        sensitive: false
      },
      awsProfile: {
        type: 'string',
        description: 'AWS CLI profile name for credentials (optional)',
        sensitive: false,
        default: ''
      },
      awsAccessKeyId: {
        type: 'string',
        description:
          'AWS access key ID (optional, use with awsSecretAccessKey instead of profile/file)',
        sensitive: true
      },
      awsSecretAccessKey: {
        type: 'string',
        description:
          'AWS secret access key (optional, use with awsAccessKeyId instead of profile/file)',
        sensitive: true
      },
      awsSessionToken: {
        type: 'string',
        description: 'AWS session token for temporary credentials (optional)',
        sensitive: true
      }
    }
  }
};

export default PrometheusServer;
